<script>
  import { cart, loadCart, withLocalePrefix } from './storage.js';
  import Money from './Money.svelte';
  import Promocode from './Promocode.svelte';
  import Delivery from './Delivery.svelte';
  import Actions from './Actions.svelte';
  import Products from './Products.svelte';

  let notEmpty = $derived($cart && $cart.order_items.length)
  let openLockerModal = $state(false);
</script>

<h1>Koszyk</h1>

{#if notEmpty}
  <div class="cart">
    <div class="main">
      <Products onrefresh={loadCart} />
    </div>
    <div class="sidebar">
      {#if !$cart.no_delivery}
        <Delivery onrefresh={loadCart} bind:openLockerModal />
      {/if}
      <Money />
      <Promocode />
      <Actions onlockermodal={() => openLockerModal = true} />
    </div>
  </div>
{:else}
  <p>Twój koszyk jest pusty :(</p>
{/if}

<style>
  .cart {
    display: grid;
    grid-column-gap: 60px;
    grid-template-columns: 2fr 1fr;
    grid-template-areas:
      "main sidebar";
    margin-bottom: 30px;
    margin-top: 30px;
  }

  @media (max-width: 767px) {
    .cart {
      grid-template-columns: 1fr;
      grid-template-areas:
        "main"
        "sidebar";
    }
  }

  .main {
    grid-area: main;
  }

  .sidebar {
    grid-area: sidebar;
  }
</style>
